// // src/modules/login/Callback.jsx
// import React, { useEffect } from 'react';
// import { useDispatch } from 'react-redux';
// import { userManager } from '../../utils/oidc';
// import { loginSuccess, logoutUser } from '@store/reducers/auth';
// import { useHistory } from 'react-router-dom';
// import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';

// const Callback = () => {
//     const dispatch = useDispatch();
//     const history = useHistory();

//     useEffect(() => {
//         // userManager.signinRedirectCallback()
//         //   .then(user => {
//         //     // user.access_token, user.id_token, user.refresh_token, user.expires_in
//         //     dispatch(loginSuccess({
//         //       expiresAt:    user.expires_in * 1000 + Date.now()
//         //     }));
//         //     // document.getElementById('root').classList.remove('register-page', 'login-page', 'hold-transition');
//         //     history.replace('/');
//         //   })
//         //   .catch(err => {
//         //     console.error(err);
//         //     dispatch(logoutUser());
//         //     history.replace('/loginsso');
//         //   });

//         const isSilentRenew =
//             window.location.pathname.includes('silent-renew.html');
//         const callbackMethod = isSilentRenew
//             ? 'signinSilentCallback'
//             : 'signinRedirectCallback';

//         userManager[callbackMethod]()
//             .then((user) => {
//                 if (user) {
//                     dispatch(
//                         apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
//                     );

//                     dispatch(
//                         loginSuccess({
//                             access_token: user.access_token,
//                             id_token: user.id_token,
//                             refresh_token: user.refresh_token,
//                             expiresAt: user.expires_in * 1000 + Date.now()
//                         })
//                     );

//                     if (!isSilentRenew) {
//                         history.replace('/');
//                     }
//                 }
//             })
//             .catch((err) => {
//                 dispatch(logoutUser());
//                 if (!isSilentRenew) {
//                     history.replace('/loginsso');
//                 }
//             });
//     }, [dispatch, history]);

//     return <div>Signing you in…</div>;
// };

// export default Callback;


// src/modules/login/Callback.jsx
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { userManager } from '@app/utils/oidc';
import { loginSuccess, logoutUser } from '@store/reducers/auth';
import { apiRoleMappingPagingAction } from '@app/store/reducers/apiRoleMapping';
import { persistor } from '@app/store/store';
import { BaseGatewayAuth } from '@app/utils/apiUrl';
import { FLASH_KEY } from '@app/utils/define';

const Callback = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      // const isSilentRenew = window.location.pathname.includes('silent-renew.html');
      const pathname = window.location?.pathname || '';
      const isSilentRenew = pathname.includes('silent-renew.html');
      const callbackMethod = isSilentRenew ? 'signinSilentCallback' : 'signinRedirectCallback';

      try {
        // 1) Lưu user OIDC vào storage
        const user = await userManager[callbackMethod]();
        if (!user) throw new Error('No user from OIDC callback');

        // 2) Đợi lấy APIRoleMapping xong
        //   - .unwrap() => fulfilled trả data, rejected ném lỗi (catch ở dưới)
        const result = await dispatch(
          apiRoleMappingPagingAction({ PageIndex: 1, PageSize: 10000 })
        ).unwrap();

        // 3) Chỉ loginSuccess khi mapping hợp lệ (có dữ liệu)
        const items = Array.isArray(result?.data) ? result.data : [];
        if (items.length === 0) throw new Error('no_mapping');

        // 4) OK → set auth state
        await dispatch(
          loginSuccess({
            access_token: user.access_token,
            id_token: user.id_token,
            refresh_token: user.refresh_token,
            expiresAt: user.expires_in * 1000 + Date.now()
          })
        );

        // 5) Điều hướng về trang chính (trừ silent renew)
        if (!isSilentRenew) history.replace('/');

      } catch (err) {
        // Mapping rỗng / callback lỗi → flash + purge + logout SSO
        try {
          localStorage.setItem(
            FLASH_KEY,
            JSON.stringify({ level: 'error', text: 'Tài khoản này không được sử dụng phần mềm này' })
          );
        } catch {}

        try {
          await persistor.flush();
          await persistor.purge();
        } catch {}

        dispatch(logoutUser());

        if (!isSilentRenew) {
          const returnUrl = encodeURIComponent(window.location.origin + '/logged-out');
          window.location.replace(
            `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${returnUrl}`
          );
        }
      }
    })();
  }, [dispatch, history]);

  return <div style={{ padding: 24 }}>Đang xử lý đăng nhập…</div>;
};

export default Callback;
